export const forEachAddon = 'ea.';
